import { computed, defineComponent, onMounted, reactive, ref, watch } from "vue";
import { Form } from "ant-design-vue";
import { ChangeService } from "@/views/safety/change/change.service";
import { useEventbus } from "@/core";
import { hmdConfirm } from "@/dialog";
export default defineComponent({
  name: "SafetyChangeSelect",
  props: {
    // 安全检测记录 ID
    value: { type: String, default: undefined },
    // 整改状态
    isChange: { type: Boolean, default: undefined },
    formName: { type: Array, default: () => [] },
    addRightBizType: {
      type: String,
      default: undefined,
    },
  },
  emits: ["update:value", "change"],
  setup(props, { emit }) {
    let isError = ref(false);
    const formItemContext = Form.useInjectFormItemContext();
    const { $on } = useEventbus();
    // 通过 safetyChangeId 获取 safetyChangeBizNo
    const { data: simpleList, run: runSimpleList } = ChangeService.useSimpleListApi();
    
    $on("form-error", (data) => {
      if (props.formName.length && data.length) {
        let nameString = props.formName.join(",");
        for (let i = 0; i < data.length; i++) {
          let errorString =
            typeof data[i]["name"] == "string" ? data[i]["name"] : data[i]["name"].join(",");
          if (errorString === nameString) {
            isError.value = true;
            break;
          } else {
            isError.value = false;
          }
        }
      }
    });
    const valueName = computed(() => {
      const exist = (simpleList.value?.records || []).find((item) => item.id === props.value);
      return exist ? exist.bizNo : "";
    });

    const showModal = () => {
      hmdConfirm({
        com: import("./dialog.vue"),
        params: {
          //@ts-ignore
          value: props.value,
          isChange: props.isChange,
          addRightBizType: props.addRightBizType,
        },
        confirm:({res})=>{
          emit("update:value", res);
          emit("change", res);
          isError.value = false;
          formItemContext.onFieldChange();
        }
      });
    };

    const removeSelected = () => {
      emit("update:value", undefined);
      emit("change", undefined);
      isError.value = true;
    };

    onMounted(async () => {
      await runSimpleList();
    });

    return {
      valueName,
      isError,
      showModal,
      removeSelected,
    };
  },
});
